import React from 'react';
import PropTypes from 'prop-types';
import AccordionComponent from 'Feature/ContentComponents/code/assets/componets/accordion';

export default class Accordion extends React.Component {
    constructor(props) {
        super(props);
        this.accordion = null;
        this.accordionRef = React.createRef();
        this.state = {
            isOpened: false
        };

        this.onAccordionStateChange = this.onAccordionStateChange.bind(this);
    }

    componentDidMount() {
        if (this.accordionRef.current) {
            this.accordion = new AccordionComponent(this.accordionRef.current, 'accordion');
            this.accordion.onChange(this.onAccordionStateChange);
        }
    }

    onAccordionStateChange(isOpened) {
        this.setState({ isOpened });
    }

    componentWillUnmount() {
        if (this.accordion) {
            this.accordion.destroy();
            this.accordion = null;
        }
    }

    render() {
        return (
            <div className="tb-form__accordion" ref={this.accordionRef} data-dc-lazy="accordion">
                <div className="tb-form__accordion-nav">
                    <button
                        className="button-tertiary"
                        type="button"
                        data-dc-accordion-ref="trigger"
                    >
                        <span className="button-content button-content--icon">
                            <span>{(this.state.isOpened && this.props.triggerOpenedText) ?
                                this.props.triggerOpenedText :
                                this.props.triggerText}</span>
                            <svg className="icon button-tertiary__icon" width="18" height="18" focusable="false">
                                {this.state.isOpened ?
                                    <use xlinkHref="#icon-arrow-up-circle"/> :
                                    <use xlinkHref="#icon-arrow-down-circle"/>
                                }
                            </svg>
                        </span>
                    </button>
                </div>
                <div className="tb-form__accordion-content">
                    <div className="tb-panels-list" data-dc-accordion-ref="content">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

Accordion.propTypes = {
    triggerText: PropTypes.string.isRequired,
    triggerOpenedText: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ])
};
